import { getCurrentUser } from '@back-office/core';
import { AxiosResponse } from 'axios';
import { http } from '../config';
import {
  CANCEL_REFUND_TX_ENDPOINT,
  GET_TRANSACTION_CSV_ENDPOINT,
  REFUND_TRANSACTION_ENDPOINT,
  REQUEST_REFUND_TX_ENDPOINT,
  REQUEST_TYPES_ENDPOINT,
  TRANSACTIONS_ENDPOINT,
  UPDATE_REF2_ENDPOINT,
  VOID_TRANSACTION_ENDPOINT,
} from '../endpoints';
import {
  CancelRefundTxArgs,
  DefaultResponse,
  RefundRequestTypesResponse,
  RequestRefundTxArgs,
  RequestRefundTxResponse,
  SuccessResponse,
  TransactionResponse,
  TransactionsListResponse,
} from '../types';

export async function getTransactionList(
  query: string
): Promise<TransactionsListResponse> {
  return http.get(`${TRANSACTIONS_ENDPOINT}?${query}`);
}

export async function getTransaction(
  txId: string
): Promise<TransactionResponse> {
  const currentUser = getCurrentUser();
  return http.get(`${TRANSACTIONS_ENDPOINT}/${txId}`, {
    params: { merchantID: currentUser.merchantID },
  });
}

export async function putVoidTransaction(
  txID: string
): Promise<SuccessResponse> {
  const currentUser = getCurrentUser();
  return http.put(
    VOID_TRANSACTION_ENDPOINT,
    { txID },
    {
      params: { merchantID: currentUser.merchantID },
    }
  );
}

export async function putRefundTransaction(
  txID: string
): Promise<SuccessResponse> {
  const currentUser = getCurrentUser();
  return http.put(
    REFUND_TRANSACTION_ENDPOINT,
    { txID },
    {
      params: { merchantID: currentUser.merchantID },
    }
  );
}

export async function getTransactionCsv(
  from: string,
  to: string
): Promise<AxiosResponse<Blob>> {
  const currentUser = getCurrentUser();
  return http.get(GET_TRANSACTION_CSV_ENDPOINT, {
    params: { merchantID: currentUser.merchantID, from, to },
    responseType: 'blob',
  });
}

export const updateRef2 = async (
  txID: string,
  ref2: string,
  merchantID: string
): Promise<SuccessResponse> =>
  http.put(`${UPDATE_REF2_ENDPOINT}?merchantID=${merchantID}`, {
    txID,
    ref2,
  });

export const requestRefundTx = async ({
  txId,
  reason,
  reasonType,
}: RequestRefundTxArgs): Promise<DefaultResponse<RequestRefundTxResponse>> => {
  const currentUser = getCurrentUser();
  return http.post(
    REQUEST_REFUND_TX_ENDPOINT,
    {
      txID: txId,
      reason,
      reasonType,
    },
    {
      params: { merchantID: currentUser.merchantID },
    }
  );
};

export const cancelRefundTx = async ({
  requestTxApprovalId,
  txID,
}: CancelRefundTxArgs): Promise<DefaultResponse<undefined>> => {
  const currentUser = getCurrentUser();
  return http.post(
    CANCEL_REFUND_TX_ENDPOINT,
    { RequestTxApprovalID: requestTxApprovalId, txID },
    { params: { merchantID: currentUser.merchantID } }
  );
};

export async function getRequestTypes(): Promise<RefundRequestTypesResponse> {
  return http.get(`${REQUEST_TYPES_ENDPOINT}`);
}
